import BaseBehavior from '../../../framework/base/base';
import { addEventListenerOnce } from '../../../shared/utilities/addListenerOnce';

export default class Accordion extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		// track accordion only when it's opened and tracking flag is on.
		if (element.hasAttribute('data-enable-tracking') && !element.querySelector('input').checked) {
			addEventListenerOnce(this.dom.header, 'click', this.track.bind(this));
		}
	}

	track() {
		const { _satellite, digitalData } = window;
		if (_satellite && digitalData) {
			digitalData.accordion = {
				...(digitalData.accordion || {}),
				title: this.dom.header.innerText,
				theme: this.element.dataset.theme
			};
			_satellite.track && _satellite.track('accordionOpened');
		}
		if (window.adobeDataLayer) {
			const componentViewed = {
				componentInfo: {
					componentId: '', // LIST id of component
					componentType: 'accordion'
				},
				measures: {
					impression: '1' // since component is in view already
				},
				accordionInfo: {
					title: this.dom.header.innerText,
					theme: this.element.dataset.theme
				}
			};
			window.adobeDataLayer.push({ event: 'componentViewed', ...componentViewed });
		}
	}
}
